import { makeStyles } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import clsx from "clsx";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useLoginStyle } from "../../../style/login.style";
import config from "../../../config/config";
import { parseInfoText } from "./parse-info-text.helper";

const useStyles = makeStyles({
  alert: {
    marginTop: 16,
  },
  title: {
    fontSize: "1.1rem",
    fontWeight: 700,
  },
  boldLink: {
    fontWeight: "bold",
  },
});

export const LoginInfoArea: FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const loginStyle = useLoginStyle();

  const text = config.loginInfoText?.trim();
  if (!text) {
    return null;
  }

  return (
    <Alert severity="info" className={classes.alert}>
      <AlertTitle className={classes.title}>{t("loginInfo.title")}</AlertTitle>
      {parseInfoText(text, clsx(loginStyle.link, classes.boldLink))}
    </Alert>
  );
};
